import React from "react"
import { useAuth } from "contexts/Auth"
import { StorageProvider as Storage_Provider } from "@cloudbreakus/storage"

export const StorageProvider = ({ children }) => {
  const { userData } = useAuth()
  return <Storage_Provider userId={userData?.userId}>{children}</Storage_Provider>
}
